module.exports = __webpack_public_path__ + "static/media/ru.ccd671ce.svg";